const keys = {
  COTACAO: {
    key: 'COTACAO',
    description: 'Cotação',
  },
  COMPRA: {
    key: 'COMPRA',
    description: 'Compra',
  },
  REQUISICAO: {
    key: 'REQUISICAO',
    description: 'Solicitação',
  },
  APROVACAO_REQUISICAO: {
    key: 'APROVACAO_REQUISICAO',
    description: 'Aprovação de solicitação',
  },
  APROVACAO_COMPRA: {
    key: 'APROVACAO_COMPRA',
    description: 'Aprovação de compra',
  },
  APROVACAO: {
    key: 'APROVACAO',
    description: 'Aprovação',
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
